<template>
  <div class="bg-white borderd">
    <div class="px-10 py-2 mx-auto mt-0">
      <div class="flex mb-20">
        <div>
          <h2 class="m-0 mb-2 font-sans leading-none text-gray-700">Tilldelade</h2>
          <select multiple class="w-64 h-64 overflow-auto form-multiselect" v-model="selectedUserRoles">
            <option v-for="r in current.roles" :key="r.id" :value="r.id">
              {{r.name}}
            </option>
          </select>
        </div>

        <div class="flex flex-col mt-32 ml-5 mr-5">
          <button class="w-24 mb-2 btn_blue" @click="onAddRoles">
            lägg till
          </button>
          <button class="w-24 btn_blue" @click="onRemoveRoles">
            ta bort
          </button>
        </div>

        <div>
          <h2 class="m-0 mb-2 font-sansleading-none text-gray-700">Tillgängliga</h2>

          <select multiple class="w-64 h-64 overflow-auto form-multiselect" v-model="selectedAvailableRoles">
            <option v-for="r in availableRoles" :key="r.id" :value="r.id">
              {{r.name}}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { RolesService } from "@/services/api-service";

export default {
  name: "userroles",
  data() {
    return {
      roles: [],
      availableRoles: [],
      selectedAvailableRoles: [],
      selectedUserRoles: []
    };
  },

  computed: {
    ...mapGetters("usersStore", ["current"])
  },

  methods: {
    ...mapActions("usersStore", ["addRoles", "removeRoles"]),
    async onAddRoles() {
      await this.addRoles(this.selectedAvailableRoles);
      this.setAvailableRoles();
    },
    async onRemoveRoles() {
      await this.removeRoles(this.selectedUserRoles);
      this.setAvailableRoles();
    },

    setAvailableRoles() {
      const anotherOne = this.current.roles;
      this.availableRoles = this.roles.filter(
        array_el =>
          anotherOne.filter(anotherOne_el => anotherOne_el.id == array_el.id)
            .length == 0
      );
    }
  },

  async mounted() {
    const { data } = await RolesService.query({ limit: 100, offset: 0 });
    this.roles = data.roles;
    this.setAvailableRoles();
  }
};
</script>
